import styled from "styled-components";

const MatchingSelectionCheckbox = styled.input`
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  margin: 0;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.buttonColor.blueNormal};

  &:disabled {
    cursor: not-allowed;
  }
`;

export default MatchingSelectionCheckbox;
